import { __decorate } from "tslib";
import { cache } from 'decorator-cache-getter';
import Cookies from 'js-cookie';
import { html, css } from 'lit';
import '@cigna/cigna_csg_gsg_cipublic-link/cipublic-link.js';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
const urlToHref = (url) => url.toString().replace(url.origin, '');
/**
 * cipublic-language-toggle
 */
export class LanguageToggle extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * The language of the target link
         */
        this.hreflang = 'en';
    }
    get hidden() {
        if (this.url.pathname.includes('/search')) {
            return true;
        }
        if (this.isHealthwise && !this.healthwiseAltHref) {
            return true;
        }
        return false;
    }
    get isHealthwise() {
        return Boolean(document.querySelector('[data-healthwise-content]'));
    }
    get healthwiseAltHref() {
        if (this.isHealthwise) {
            const alternateLink = document.querySelector('link[rel="alternate"]');
            const hasAlternateHrefLang = Boolean(alternateLink === null || alternateLink === void 0 ? void 0 : alternateLink.getAttribute('hreflang'));
            if (hasAlternateHrefLang) {
                return alternateLink === null || alternateLink === void 0 ? void 0 : alternateLink.getAttribute('href');
            }
        }
        return false;
    }
    get url() {
        const healthwiseAltHref = this.healthwiseAltHref;
        if (healthwiseAltHref) {
            return new URL(healthwiseAltHref);
        }
        const url = new URL(document.location.href);
        const currentIsSpanish = url.pathname.startsWith('/es-us/');
        if (this.hreflang === 'es') {
            if (!currentIsSpanish) {
                url.pathname = `/es-us/${url.pathname.substring(1)}`;
            }
        }
        else {
            if (currentIsSpanish) {
                url.pathname = url.pathname.replace(/^\/es-us\//, '/');
            }
        }
        return url;
    }
    handleClick(e) {
        e.preventDefault();
        if (this.hreflang === 'es') {
            Cookies.set('language', 'spanish');
        }
        else {
            Cookies.remove('language');
        }
        document.location.assign(urlToHref(this.url));
    }
    connectedCallback() {
        super.connectedCallback();
        if (!Cookies.get('language404') && !this.hidden) {
            if (Cookies.get('language') && this.hreflang === 'es') {
                // on en page but have language cookie
                if (!document.location.pathname.startsWith('/es-us/')) {
                    // const newUrl = this.url;
                    // newUrl.pathname = `/es-us/${this.url.pathname.substring(1)}`;
                    location.replace(urlToHref(this.url));
                }
            }
        }
        else {
            Cookies.remove('language404', { domain: '.cigna.com' });
        }
        if (!this.hidden) {
            this.style.display = 'block';
        }
    }
    render() {
        return html `<cipublic-link href="${urlToHref(this.url)}" hreflang="${this.hreflang}" @click="${this.handleClick}"><slot name="lang"></slot></cipublic-link>`;
    }
}
LanguageToggle.styles = css `:host{display:none}`;
__decorate([
    property({ reflect: true })
], LanguageToggle.prototype, "hreflang", void 0);
__decorate([
    cache
], LanguageToggle.prototype, "hidden", null);
__decorate([
    cache
], LanguageToggle.prototype, "isHealthwise", null);
__decorate([
    cache
], LanguageToggle.prototype, "healthwiseAltHref", null);
__decorate([
    cache
], LanguageToggle.prototype, "url", null);
//# sourceMappingURL=language-toggle.js.map